import {
  IAcademicBackEndModelHigher,
  IAcademicFormModelHigher,
} from "../../../types";

export function parseToBackEndModel(
  frontendModel: IAcademicFormModelHigher,
  schoolId: string,
  academicId?: string,
): IAcademicBackEndModelHigher {
  const degree = frontendModel.degrees[frontendModel.selectedDegree.id];

  const backendModel = {} as IAcademicBackEndModelHigher;

  backendModel.schoolId = schoolId;
  backendModel.degreeId = frontendModel.selectedDegree.id;

  if (academicId) {
    backendModel.id = academicId;
  }

  backendModel.requiredDocs = degree.requiredDocs.map((doc) => {
    const parsedDoc = { ...doc };
    delete parsedDoc.shortName;
    delete parsedDoc.longName;

    return parsedDoc;
  });

  Object.entries(degree.additionalDocuments || {}).forEach(([id, name]) => {
    if (!name.trim()) {
      return;
    }

    const doc: { id?: string; name: string } = { name: name.trim() };

    if (!id.startsWith("_")) {
      doc.id = id;
    }

    backendModel.requiredDocs.push(doc);
  });

  if (degree.applicationForms!.length) {
    backendModel.applicationForms = degree.applicationForms!.map((form) => ({
      fileId: form.id,
    }));
  } else {
    backendModel.applicationForms = [];
  }

  if (degree.applicationLink) {
    backendModel.applicationLink = degree.applicationLink.trim();
  } else {
    backendModel.applicationLink = null;
  }

  return backendModel;
}
